import type { TaskListResponse } from '../../services/api/types.gen';
import { parseISOToLocalDate } from '../../utils/dateUtils';

/** Active table: task date ascending, then id (stable same-day order). */
export function sortTasksForActiveTableDisplay(
  tasks: TaskListResponse[]
): TaskListResponse[] {
  return [...tasks].sort((a, b) => {
    const dateA = parseISOToLocalDate(a.task_date)?.getTime() ?? 0;
    const dateB = parseISOToLocalDate(b.task_date)?.getTime() ?? 0;
    if (dateA !== dateB) return dateA - dateB;
    return a.id.localeCompare(b.id);
  });
}

const allViewSortKey = (task: TaskListResponse) =>
  task.scheduled_date || task.task_date || '';

/** All view: scheduled date, else task date, then id. Live and deleted interleaved. */
export function sortTasksForAllTableDisplay(
  liveTasks: TaskListResponse[],
  deletedTasks: TaskListResponse[]
): TaskListResponse[] {
  return [...liveTasks, ...deletedTasks].sort((a, b) => {
    const byDate = allViewSortKey(a).localeCompare(allViewSortKey(b));
    return byDate !== 0 ? byDate : a.id.localeCompare(b.id);
  });
}
